import { normalize, schema } from 'normalizr';

export const entity = 'vendor';
export const endpoints = {
  all: {
    url: '/admin/vendors/all',
    entity,
    list: true,
  },
  create: ({ payload, onSuccess }) => ({
    url: '/admin/vendors',
    payload,
    entity,
    list: false,
    onSuccess,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorID',
  }
);
export const normalizer = (result) => normalize(result.vendors, entitySchema);
export const listNormalizer = (result) => normalize(result.vendors, [entitySchema]);
